// AroInsightsScreen.jsx

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";

import SearchRequests from "../components/SearchRequests";

import { DEFAULT_HOTEL } from "../configuration";

import {
    error_AroInsights,
    load_AroInsights,
    loading_AroInsights,
} from "../features/aroInsightsApi/dataAroInsightsSlice";
import { useGetAroInsightsQuery } from "../features/aroInsightsApi/aroInsightsApi";

const AroInsightsScreen = () => {
    const dispatch = useDispatch();

    const { id: selectedHotelID = "default" } = useSelector(
        (state) => state.hotelID,
    );
    const jwt = useSelector((state) => state.auth.user?.jwt);

    const hotelID =
        selectedHotelID === "default" ? DEFAULT_HOTEL : selectedHotelID;

    const query = useGetAroInsightsQuery(hotelID, {
        skip: !jwt || !hotelID || hotelID === "default",
        refetchOnMountOrArgChange: 300,
    });

    useEffect(() => {
        if (query.isError) {
            dispatch(
                error_AroInsights({
                    hotelID,
                    error:
                        query.error?.data?.message ||
                        query.error?.error ||
                        "Could not load Aro Insights.",
                }),
            );
        } else if (query.currentData) {
            dispatch(
                load_AroInsights({
                    hotelID,
                    data: query.currentData,
                }),
            );
        } else if (query.isFetching) {
            dispatch(loading_AroInsights({ hotelID }));
        }
    }, [
        dispatch,
        hotelID,
        query.currentData,
        query.error,
        query.isError,
        query.isFetching,
    ]);

    return (
        <>
            <Grid container>
                <Grid item sx={{ mt: 2, ml: 2 }} xs={12}>
                    <Typography variant="h4">Lost Revenue report</Typography>
                    <Typography>
                        ⚠️ This report may take a while to load.
                    </Typography>
                    <Typography>
                        ⚠️ The data shown in this report may be inaccurate.
                    </Typography>
                </Grid>
            </Grid>

            <SearchRequests hotelID={hotelID} />
        </>
    );
};

export default AroInsightsScreen;
